module.exports = __webpack_public_path__ + "static/media/volume.2e84f1d5.svg";